export default __webpack_public_path__ + "static/media/kitchen3-afterH-768w.72a0043b.png";